var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTpoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 202,
    viewBox: "0 0 275 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6016,
    cy: 1.0127,
    r: 200,
    fill: "#F9C626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpoCircle);
export default __webpack_public_path__ + "static/media/tpo_circle.158fe0a7d2e976b054ed09810e7c018e.svg";
export { ForwardRef as ReactComponent };